// Widget CSS
import '@/css/_elementor/widgets/related_articles.css';

// ..........................................................................................

function initThisCarousel(scopeEl) {
	const slider1 = scopeEl.querySelector('.slider-related_articles');

	if (slider1) {
		new Swiper(slider1, {
			speed: 750,
			loop: false,
			freeMode: true,
			grabCursor: true,
			watchSlidesProgress: false,
			spaceBetween: 14,
			slidesPerView: 1,
			slidesOffsetAfter: 20,

			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 16,
					initialSlide: 1,
					centeredSlides: true,
					slidesOffsetAfter: 0,
				},
				1280: {
					slidesPerView: 3,
					spaceBetween: 24,
					initialSlide: 1,
					slidesOffsetAfter: 0,
				},
				1600: {
					slidesPerView: 4,
					spaceBetween: 25,
					initialSlide: 1,
					slidesOffsetAfter: 0,
				},
				1920: {
					slidesPerView: 4,
					spaceBetween: 27,
					initialSlide: 1,
					slidesOffsetAfter: 0,
				},
			},
			pagination: {
				el: '.slider-related_articles .swiper-pagination',
				type: 'bullets',
				dynamicBullets: false,
				clickable: true,
			},
			// navigation: {
			// 	nextEl: '.slider-related_articles .slider-button-next',
			// 	prevEl: '.slider-related_articles .slider-button-prev',
			// },
		});
	}
}

// ......

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/related_articles.default', (scope) => {
		const scopeEl = scope[0];

		// ......................................................

		initThisCarousel(scopeEl);

		// ......................................................
	});
});
